import { setGlobalDevModeChecks } from 'reselect'

// Never run the identity function check in development mode
// there are plenty of places where we used createSelector with a single argument, refactoring all places could be a big risk of getting unexpected bugs
// after updating 'reselect' to version 5 it becomes a warning, so we are disabling this check for now
setGlobalDevModeChecks({ identityFunctionCheck: 'never' })
